import React, { Suspense, useState, useMemo, useEffect } from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import lightBlue from "@material-ui/core/colors/lightBlue";
import blue from "@material-ui/core/colors/blue";
// import lightPink from "@material-ui/core/colors/cyan";
import pink from "@material-ui/core/colors/pink";
import red from "@material-ui/core/colors/red";
import ls from "local-storage";
/* global cordova:readonly */

const App = React.lazy(() => import("./App"));
export const isDarkMode = (onSuccess) => {
  // console.log('isDarkMode');
  if (
    typeof cordova !== "undefined" &&
    cordova &&
    cordova.plugins &&
    cordova.plugins.ThemeDetection &&
    typeof cordova.plugins.ThemeDetection.isDarkModeEnabled === "function"
  ) {
    cordova.plugins.ThemeDetection.isDarkModeEnabled(onSuccess);
  } else {
    onSuccess({ message: "No Plugin", value: false, cordova: typeof cordova });
  }
};
const AppWrapper = () => {
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const getTheme = () => {
    const t = ls("theme");
    // console.log('t', t);
    if (t && t.substr(0, 1) === '"') return JSON.parse(t);
    if (t) return t;
    return "system";
  };
  const [modeFromPlugin, setModeFromPlugin] = useState(false);
  const [modeFromSettings, setModeFromSettings] = useState(getTheme);

  // console.log("LS", ls.get());
  const setThemeMode = (m) => {
    ls.set("theme", m);
    // localStorage.setItem("theme", m);
    setModeFromSettings(m);
  };
  // console.log('modeFromPlugin', modeFromPlugin);
  // const themeMode = ls('themeMode') || 'system';

  const isDark = useMemo(() => {
    if (modeFromSettings === "dark") return true; // app set to dark
    if (modeFromSettings === "light") return false; // app set to light
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    )
      return true; // css set to dark
    if (modeFromPlugin === false) {
      isDarkMode(setModeFromPlugin);
    }
    if (typeof modeFromPlugin === "object" && modeFromPlugin.value)
      return modeFromPlugin.value;
    return false;
  }, [modeFromSettings, modeFromPlugin]);
  // console.log('isDark', isDark, modeFromPlugin, modeFromSettings);

  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: {
          primary: isDark ? lightBlue : blue,
          secondary: isDark
            ? {
                light: "#f48fb1",
                main: "#f06292",
                dark: "#ec407a",
              }
            : pink,
          error: red,
          contrastThreshold: 3,
          tonalOffset: 0.2,
          type: isDark ? "dark" : "light",
        },
      }),
    [isDark]
  );

  // useEffect(() => {
  //   if (
  //     typeof StatusBar !== "undefined" &&
  //     StatusBar &&
  //     StatusBar.backgroundColorByHexString
  //   ) {
  //     StatusBar.backgroundColorByHexString(theme.palette.background.paper);
  //     if (isDark) {
  //       StatusBar.styleLightContent();
  //     } else {
  //       StatusBar.styleDefault();
  //     }
  //   }
  // });
  // console.log('theme', theme);
  // debug={JSON.stringify({ isDark, modeFromPlugin, modeFromSettings })}
  useEffect(() => {
    document.body.style.backgroundColor = theme.palette.background.paper;
    // document.body.style.color = theme.palette.text.primary;
  }, [theme]);
  return (
    <Suspense
      fallback={
        <Backdrop open>
          <CircularProgress />
        </Backdrop>
      }
    >
      <ThemeProvider theme={theme}>
        <App setThemeMode={setThemeMode} appTheme={modeFromSettings} />
      </ThemeProvider>
    </Suspense>
  );
};

export default AppWrapper;
